export default {
    container: {
        color: 'rgba(26,26,26,.9)',
        marginTop: 50
    },
    servicesHeader: {
        marginTop: 0,
        color: 'rgb(61, 153, 145)'
    },
    servicesDesc: {
        textAlign: 'justify',
        marginBottom: 50
    },
    serviceDetailLink: {
        textDecoration: 'none',
        fontSize: '1.1em'
    }
}


// WEBPACK FOOTER //
// ./src/containers/ServiceDetail/ServiceDetailStyle.js